<template>
  <v-row justify="center" class="joinform-page">
    <v-card
      width="100%"
      class="text-xs-center mt-8 elevation-12"
      max-width="800px"
    >
      <v-row justify="center" class="ma-0">
        <v-col class="px-8 py-0 text-left joinform-title">
          {{ $t('회원가입') }}
        </v-col>
      </v-row>
      <v-row class="ma-0 mb-10 mt-6">
        <v-col cols="12" class="col-md-6 pl-8 pr-4 py-0">
          <v-form ref="form">
            <i-text-field
              v-model="name"
              :prepend-inner-icon="mdiAccount"
              :rules="[rules.required, rules.noSpecialChar]"
              label="이름을 입력해주세요."
              required
              outlined
              dense
            ></i-text-field>
            <div class="overlap-wrap">
              <i-text-field
                ref="email"
                v-model="email"
                :prepend-inner-icon="mdiEmail"
                :error-messages="emailErrors"
                label="이메일을 입력해주세요."
                :rules="[rules.required]"
                required
                :readonly="emailCheckType == 'V' || emailCheckType == 'S'"
                @input="$v.email.$touch()"
                @blur="$v.email.$touch()"
                outlined
                dense
              ></i-text-field>
              <i-btn
                v-if="emailCheckType == 'C' || emailCheckType == 'D'"
                rounded
                outlined
                small
                color="primary"
                class="overlap-confirm"
                @click="emailCheck"
                >중복확인</i-btn
              >
              <i-btn
                v-if="emailCheckType == 'V'"
                rounded
                outlined
                small
                color="primary"
                class="overlap-confirm"
                @click="sendEmailCode"
                >인증메일발송</i-btn
              >
              <i-btn
                v-if="emailCheckType == 'S'"
                rounded
                outlined
                small
                color="primary"
                class="overlap-confirm"
                :disabled="resendCooldown > 0"
                @click="sendEmailCode"
                >{{
                  resendCooldown > 0
                    ? `재발송(${resendCooldown}초)`
                    : '인증메일재발송'
                }}</i-btn
              >
            </div>
            <div class="overlap-wrap" v-if="emailCheckType == 'S'">
              <v-alert
                dense
                outlined
                type="info"
                class="mt-2 mb-4 verify-mail-alert"
              >
                <div>
                  {{ $t('입력한 이메일로 인증 링크를 발송했습니다.') }}
                </div>
                <div>
                  {{ $t('인증 완료 후 회원가입 버튼을 눌러주세요.') }}
                </div>
              </v-alert>
            </div>
            <div class="overlap-wrap">
              <i-text-field
                ref="phone"
                v-model="phone"
                :prepend-inner-icon="mdiPhone"
                :rules="[rules.required, rules.phone]"
                required
                label="핸드폰번호를 입력해주세요"
                class="input-group--focused"
                @input="$v.phone.$touch()"
                @blur="$v.phone.$touch()"
                outlined
                dense
              >
              </i-text-field>
            </div>
            <i-text-field
              v-model="password"
              :prepend-inner-icon="mdiKey"
              :append-icon="show1 ? mdiEye : mdiEyeOff"
              :rules="[
                rules.required,
                rules.min,
                rules.char,
                rules.number,
                rules.specialChar,
              ]"
              :type="show1 ? 'text' : 'password'"
              label="비밀번호를 입력해주세요"
              hint="At least 8 characters"
              value="wqfasds"
              class="input-group--focused"
              @click:append="show1 = !show1"
              @input="$v.password.$touch()"
              @blur="$v.password.$touch()"
              outlined
              dense
            ></i-text-field>
            <i-text-field
              v-model="passwordCheck"
              :prepend-inner-icon="mdiKey"
              :append-icon="show2 ? mdiEye : mdiEyeOff"
              :rules="[
                rules.required,
                rules.min,
                rules.char,
                rules.number,
                rules.specialChar,
                rules.passwordMatch,
              ]"
              :type="show2 ? 'text' : 'password'"
              label="비밀번호를 확인해주세요"
              hint="At least 8 characters"
              value="wqfasds"
              class="input-group--focused"
              @click:append="show2 = !show2"
              @input="$v.passwordCheck.$touch()"
              @blur="$v.passwordCheck.$touch()"
              outlined
              dense
            ></i-text-field>
            <v-subheader class="text-left info-msg">{{
              $t(
                '비밀번호는 8~16자의 영문 대소문자, 숫자 및 특수문자를 사용해주시기바랍니다.',
              )
            }}</v-subheader>
          </v-form>
        </v-col>
        <v-col cols="12" class="col-md-6 text-center pl-4 pr-8 py-0">
          <template>
            <v-container fluid class="py-0 right-container">
              <!--              <ckeditor-->
              <!--                class="terms"-->
              <!--                style="height: 360px"-->
              <!--                :editor="editor"-->
              <!--                :config="editorConfig"-->
              <!--                @ready="editorInit"-->
              <!--                v-model="personalPolicy.privacyPolicy"-->
              <!--              ></ckeditor>-->
              <CommonCkEditor
                style="height: 360px"
                :isReadOnly="true"
                v-model="personalPolicy.privacyPolicy"
              />
              <!--
              <div
                class="terms"
                v-html="personalPolicy.privacyPolicy"
                style="height: 360px"
              ></div>
              -->
              <i-checkbox
                v-model="checkbox1"
                label="개인정보 수집 및 이용에 대한 동의"
              ></i-checkbox>
            </v-container>
          </template>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row justify="space-between" class="ma-0 px-6 py-4">
        <i-btn text color="#777e87" class="" @click="goLoginPage">로그인</i-btn>
        <i-btn color="primary" @click="submitJoin">회원가입</i-btn>
      </v-row>
    </v-card>
  </v-row>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';

import { getEncryption, postJson } from '@/api/network';
import { getJson } from '@/api/network';
import { DialogMixin } from '@/mixin/dialog.js';
import { LoadingMixin } from '@/mixin/loading.js';

import CommonCkEditor from '@/components/common/CommonCkEditor.vue';

import RSAKey from '@/utils/rsa/rsa.js';

import {
  mdiAccount,
  mdiEmail,
  mdiKey,
  mdiEye,
  mdiEyeOff,
  mdiPhone,
} from '@mdi/js';

const RESEND_COOLDOWN_SECONDS = 60;

export default {
  components: { CommonCkEditor },
  mixins: [validationMixin, DialogMixin, LoadingMixin],
  validations: {
    email: { required, email },
    phone: { required },
    password: { required },
    passwordCheck: { required },
  },
  props: {
    routeParam: Object,
  },
  data() {
    return {
      mdiAccount,
      mdiPhone,
      mdiEmail,
      mdiKey,
      mdiEye,
      mdiEyeOff,
      name: '',
      email: '',
      phone: '',
      password: '',
      passwordCheck: '',
      logMessage: '',
      invalid: false,
      show1: false,
      show2: false,
      rules: {
        required: value => !!value || '필수입력 사항입니다.',
        min: v => v.length >= 8 || '최소 8자 이상 입력하셔야합니다.',
        char: v =>
          /(?=.*[a-zA-Z])/.test(v) || '최소 하나의 영문자가 필요합니다.',
        number: v => /(?=.*\d)/.test(v) || '최소 하나의 숫자가 필요합니다.',
        noSpecialChar: v =>
          !/([!@#$%])/.test(v) || '특수문자는 허용되지 않습니다.',
        specialChar: v =>
          /([!@#$%])/.test(v) || '최소 하나의 특수문자가 필요합니다. [!@#$%]',
        passwordMatch: value =>
          value === this.password || '비밀번호가 일치하지 않습니다.',
        phone: v =>
          /(01[016789])([1-9]{1}[0-9]{2,3})([0-9]{4})$/.test(v) ||
          '핸드폰 번호 형식을 다시 확인해 주세요.',
      },
      checkbox1: false,
      checkbox2: false,
      personalPolicy: {},
      sensitivePolicy: {},
      emailCheckType: 'C', // 'C': 중복확인, 'V': 유효한 이메일, 'D': 이메일 중복, 'S': 이메일 전송 'R': 삭제된 이메일
      resendCooldown: 0,
      resendCooldownTimer: null,
    };
  },
  created() {
    this.getPolicy();
  },
  beforeDestroy() {
    this.stopResendCooldown();
  },
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push(this.$t('이메일 형식을 확인하세요.'));
      !this.$v.email.required && errors.push(this.$t('필수 입력사항입니다.'));
      this.emailCheckType == 'D' &&
        errors.push(this.$t('이미 가입되어 있는 이메일입니다.'));
      this.emailCheckType == 'R' &&
        errors.push(this.$t('이미 탈퇴한 계정입니다.'));
      return errors;
    },
  },
  methods: {
    editorInit(editor) {
      //READ-ONLY
      editor.isReadOnly = true;
      var element = editor.ui.view.toolbar.element;
      element.style.display = 'none';

      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(element, editor.ui.getEditableElement());
    },
    initForm() {
      this.email = '';
      this.password = '';
    },
    goLoginPage() {
      this.$router.push('/login/' + this.$route.params.tenantKey);
    },
    getPolicy() {
      try {
        getJson(
          'info/' + this.$route.params.tenantKey + '/join/privacyPolicy',
          {},
        ).then(res => {
          if (res.data.hasOwnProperty('personalPolicy'))
            this.personalPolicy = res.data.personalPolicy;

          if (res.data.hasOwnProperty('sensitivePolicy'))
            this.sensitivePolicy = res.data.sensitivePolicy;
        });
      } catch (error) {
        console.log(error);
        //this.logMessage = error.response.data;
      }
    },
    async emailCheck() {
      this.emailCheckType = 'C';
      this.$v.$touch();

      if (this.$refs.email.validate() && this.emailErrors.length == 0) {
        try {
          const rsa = new RSAKey();
          const {
            publicKeyModulus,
            publicKeyExponent,
            sessionKey,
          } = await getEncryption();
          rsa.setPublic(publicKeyModulus, publicKeyExponent);
          const p = {
            email: rsa.encrypt(this.email),
            sessionKey: sessionKey,
          };
          getJson(
            'api/login/' + this.$route.params.tenantKey + '/email/check',
            p,
          )
            .then(res => {
              if (res.data && res.data.hasOwnProperty('code')) {
                //휴면계정일 경우
                if (res.data.code == 'H') {
                  this.showAlert({
                    message:
                      '해당 계정은 휴면계정입니다. 휴면해제 화면으로 이동합니다.',
                    callback: this.goDormantUserClear,
                    param: this.email,
                  });
                } else {
                  // 이메일 인증 완료
                  this.emailCheckType = res.data.code;
                }
              }
            })
            .catch(error => {
              console.log(error.response);
            });
        } catch (error) {
          console.log(error);
        }
      }
    },
    // 이메일이 유효하고 중복확인을 통과한 상태(V)라면 그것만으로 인증메일을 발송한다.
    // 이름/전화/비밀번호 입력 여부는 여기서 검사하지 않는다 - 그 검사는 "회원가입" 버튼(submitJoin)에서 한다.
    async sendEmailCode() {
      if (this.emailCheckType == 'S' && this.resendCooldown > 0) return;
      if (this.emailCheckType != 'V' && this.emailCheckType != 'S') return;

      try {
        this.showLoading();
        const rsa = new RSAKey();
        const {
          publicKeyModulus,
          publicKeyExponent,
          sessionKey,
        } = await getEncryption();
        rsa.setPublic(publicKeyModulus, publicKeyExponent);
        const p = {
          email: rsa.encrypt(this.email),
          sessionKey: sessionKey,
        };

        postJson(
          'api/login/' +
            this.$route.params.tenantKey +
            '/join/vue/sendVerifyMail',
          p,
        )
          .then(res => {
            this.hideLoading();

            if (res.data != null && res.data.hasOwnProperty('status')) {
              if (res.data.status == 'success') {
                this.emailCheckType = 'S';
                this.startResendCooldown();
              }

              if (this.$route.params.tenantKey == 'ey') {
                this.$showAlert(
                  res.data.message +
                    '\n\n' +
                    '※ 인증메일이 수신되지 않을 경우, 아래 사항을 확인해 주세요:\n\n' +
                    '1. 📂 스팸(정크) 메일함을 확인해 주세요.\n' +
                    '2. 🧹 메일 저장용량이 가득 찼는지 확인해 주세요.\n' +
                    '3. 📧 다른 이메일 주소를 사용해 가입을 시도해 보세요.\n\n' +
                    '❗ 그래도 메일을 받지 못하셨다면 관리자에게 문의해 주세요. (recruiting@kr.ey.com)',
                );
              } else {
                this.$showAlert(
                  res.data.message +
                    '\n\n' +
                    '※ 인증메일이 수신되지 않을 경우, 아래 사항을 확인해 주세요:\n\n' +
                    '1. 📂 스팸(정크) 메일함을 확인해 주세요.\n' +
                    '2. 🧹 메일 저장용량이 가득 찼는지 확인해 주세요.\n' +
                    '3. 📧 다른 이메일 주소를 사용해 가입을 시도해 보세요.\n\n' +
                    '❗ 그래도 메일을 받지 못하셨다면 관리자에게 문의해 주세요.',
                );
              }
            }
          })
          .catch(error => {
            this.hideLoading();
            console.log(error.response);
            this.$showAlert(
              '인증 메일 발송 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
            );
          });
      } catch (error) {
        this.hideLoading();
        console.log(error);
        this.$showAlert(
          '인증 메일 발송 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
        );
      }
    },
    // "회원가입" 버튼: 폼 유효성 + 약관 동의를 검사하고, 이메일 인증(메일의 링크 클릭)이
    // 끝났는지는 서버(completeJoin)에서 최종 확인한다.
    async submitJoin() {
      this.$v.$touch();

      if (!this.$refs.form.validate() || this.emailErrors.length != 0) {
        document
          .querySelector('.error--text')
          ?.scrollIntoView({ block: 'center' });
        return;
      }

      if (!this.checkbox1) {
        this.$showAlert(
          '개인정보 수집 및 이용 약관과 민감정보 수집 및 이용에 관한 사항에 모두 동의해주세요.',
        );
        return;
      }

      if (this.emailCheckType != 'S') {
        this.$showAlert('먼저 이메일 중복확인과 인증메일 발송을 진행해주세요.');
        return;
      }

      try {
        this.showLoading();
        const rsa = new RSAKey();
        const {
          publicKeyModulus,
          publicKeyExponent,
          sessionKey,
        } = await getEncryption();
        rsa.setPublic(publicKeyModulus, publicKeyExponent);
        const p = {
          email: rsa.encrypt(this.email),
          name: rsa.encrypt(this.name),
          phone: rsa.encrypt(this.phone),
          password: rsa.encrypt(this.password),
          personalAgreeId: this.personalPolicy.privacyPolicyId,
          sessionKey: sessionKey,
        };

        const res = await postJson(
          'api/login/' + this.$route.params.tenantKey + '/join/vue/complete',
          p,
        );

        this.hideLoading();

        if (res.data && res.data.status == 'success') {
          this.stopResendCooldown();
          this.showAlert({
            message: res.data.message,
            callback: this.goLoginPage,
          });
        } else if (res.data && res.data.code == 'NOT_VERIFIED') {
          this.$showAlert(
            '이메일 인증이 완료되지 않았습니다. 메일함에서 인증 링크를 클릭한 후 다시 시도해주세요.',
          );
        } else {
          this.$showAlert(
            (res.data && res.data.message) ||
              '회원가입 처리 중 오류가 발생했습니다.',
          );
        }
      } catch (error) {
        this.hideLoading();
        console.log(error);
        this.$showAlert(
          '회원가입 처리 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
        );
      }
    },
    goDormantUserClear(email) {
      this.$router.push({
        name: 'dormant',
        params: { tenantKey: this.$route.params.tenantKey, email: email },
      });
    },
    startResendCooldown() {
      this.resendCooldown = RESEND_COOLDOWN_SECONDS;
      this.stopResendCooldown();
      this.resendCooldownTimer = setInterval(() => {
        this.resendCooldown -= 1;
        if (this.resendCooldown <= 0) this.stopResendCooldown();
      }, 1000);
    },
    stopResendCooldown() {
      if (this.resendCooldownTimer) {
        clearInterval(this.resendCooldownTimer);
        this.resendCooldownTimer = null;
      }
    },
  },
};
</script>

<style>
/* .v-card {
  opacity: 0.8;
} */
.v-subheader.info-msg {
  align-items: baseline;
}
.overlap-wrap {
  position: relative;
}
.overlap-wrap .v-text-field input {
  width: 70%;
  max-width: 70%;
}
.overlap-confirm {
  position: absolute;
  right: 10px;
  top: 10px;
}
.timer {
  top: 18px;
  font-size: 14px;
  color: #1976d2;
}
.timer .over {
  color: red;
}
.info-msg::before {
  content: '※';
}
.verify-mail-alert div {
  line-height: 22px;
}
.verify-mail-alert div + div {
  margin-top: 4px;
}
.v-input--selection-controls:first-child {
  margin-top: 0px;
} /* policy term */
.terms {
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  padding: 10px 12px;
  border: 1px solid #ccc;
  font-size: 14px;
  line-height: 22px;
  text-align: left;
  background-color: #fff;
  color: gray;
} /* tablet */
@media all and (max-width: 768px) {
  .v-sheet {
    height: auto !important;
    box-shadow: none !important;
  }
}

/* 김대식 css 작업구간 */

.joinform-page .joinform-title {
  padding: 24px 32px !important;
  font-size: 18px;
  font-weight: 700;
  border-bottom: 1px solid #d5d8dc;
  color: #363c43;
}

.joinform-page .v-card {
  border-radius: 20px !important;
}
.joinform-page .v-input__slot {
  min-height: 38px !important;
}
.joinform-page .v-icon {
  font-size: 18px !important;
}
.joinform-page .v-label {
  font-size: 14px;
}

.joinform-page .overlap-confirm {
  /* height: 38px !important; 
  position: static; 
  color: #fff; */
  top: 3px !important;
  height: 32px !important;
  font-size: 14px !important;
  background-color: #465166 !important;
  border-radius: 4px !important;
  color: #fff !important;
}

.joinform-page .overlap-confirm.timer {
  display: flex !important;
  align-items: center !important;
  background-color: #fff !important;
  color: #363c43 !important;
}

.right-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

/* 김대식 css 작업구간 */
</style>
